import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'bsType',
                label: '业务专项',
                type: 'select',
                selectval: comMapping.$ywzx
            }, {
                prop: 'code',
                label: '业务代码',
                type: 'input'
            }, {
                prop: 'bsName',
                label: '业务名称',
                type: 'input'
            }, {
                prop: 'resRange',
                label: '取值范围',
                type: 'select',
                selectval: comMapping.$qzfw
            },  {
                prop: 'dataType',
                label: '数据类型',
                type: 'select',
                selectval: comMapping.$sjlx
            }
        ],
        searchdata: {
            bsType: '',
            code: '',
            bsName: ''
        },
        headData: [
            {
                title: '序号',
                prop: 'serialNumber',
                width: 50,
                custom: true

            },
            {
                title: '业务专项',
                prop: 'bsType',
                width: 130,
                custom: true

            },
            {
                title: '业务代码',
                prop: 'code',
                width: 130,
                custom: true

            },
            {
                title: '业务名称',
                prop: 'bsName',
                width: 150,
                custom: true

            },
            {
                title: '取值范围',
                prop: 'resRange',
                width: 130,
                custom: true

            },
            {
                title: '数据类型',
                prop: 'dataType',
                width: 130,
                custom: true

            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 200
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
